import { z } from "zod";

export const schema = z.object({
	id_empresa: z.number().min(1, "Selecione uma empresa"),
	dias_periodo: z.number().optional().default(0),
	dns_catalogo: z.string().optional().nullable(),
});

export const defaultValues = {
	id_empresa: 0,
	dias_periodo: 0,
	dns_catalogo: "",
};
